// plugins/toasts.client.ts
import type { ToastType } from "~/composables/useToasts";

type ShowToastParams = {
  msg: string;
  type?: ToastType;
  duration?: number;
};

export default defineNuxtPlugin(() => {
  const { showToast } = useToasts();

  const show = ({ msg, type = "info", duration }: ShowToastParams) => {
    showToast(msg, type, duration);
  };

  return {
    provide: {
      showToast: show,
    },
  };
});
